import React from 'react';
import App from '../App/App';
import AboutCards from './AboutCards';
import AboutBanner from './AboutBanner';
import Introduce from './Introduce';
import CourseCard from './CourseCard';
import Product from './Product';
import ProductCard from './ProductCard';
import SolutionCard from './SolutionCard';
import Advantage from './Advantage';
import AdvantageCard from './AdvantageCard';
import Copyright from './Copyright';
import {banner, introduce, course, product, solution, advantage, copyright} from './config';

function About() {
  if (!global.isServer) {
    document.title = '关于我们-云恋科技，您身边的供应链专家';
  }
  return (
    <App className='About'>
      <AboutBanner data={banner} />
      <Introduce title='公司介绍' {...introduce} grey />
      <AboutCards title='发展历程' {...course} md={1}>
        <CourseCard />
      </AboutCards>
      <Product title='我们的产品' {...product} lg={2} md={1} grey>
        <ProductCard />
      </Product>
      <AboutCards title='我们的解决方案' {...solution} lg={3} md={2}>
        <SolutionCard />
      </AboutCards>
      <Advantage data={advantage} md={2}>
        <AdvantageCard />
      </Advantage>
      <Copyright title='知识产权' {...copyright} />
    </App>
  );
}

export default About;



// WEBPACK FOOTER //
// ./src/routes/About/About.js